export default __webpack_public_path__ + "static/media/family2.0605f482.svg";